import { useEffect, useState } from 'react'

/**
 * Render children on only client side.
 * It is error-free component for SSR
 *
 * @prop children content to render only on client-side
 */

const ClientOnly: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    // https://nextjs.org/docs/messages/react-hydration-error
    setIsClient(true)
  }, [])

  if (!isClient) return null

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}

export default ClientOnly
